import { render, staticRenderFns } from "./DeleteMarketRule.vue?vue&type=template&id=a3e3a5ac"
import script from "./DeleteMarketRule.vue?vue&type=script&lang=js"
export * from "./DeleteMarketRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports